import { type ReactElement, type ReactNode, useState } from "react"
import { useLocation } from "react-router-dom"
import { UserManagementHome } from "src/features/userManagement"
import { RootState } from "src/app/store";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "src/features/authentication/hooks/userAuth";
import { useDispatch, useSelector } from "react-redux";
import { useIdleTimer } from "react-idle-timer";
import LogoutModal from "src/features/authentication/components/LogoutModal";
import { AppDispatch } from "src/app/store";

export interface UserManagementProps {
        children?: ReactNode
}

export function UserManagementPage(props: UserManagementProps): ReactElement {
        const location = useLocation();
        const dealerId = location.state?.dealerID;
        const history = location.state?.from;
        const navigate = useNavigate();
        const { authUser } = useSelector((state: RootState) => state.auth);
        const [showLogoutModal, setShowLogoutModal] = useState(false);
        const dispatch = useDispatch<AppDispatch>();

        const onIdle = () => {
                setShowLogoutModal(false);
                if (showLogoutModal) {
                        dispatch(logoutUser(authUser));
                        dispatch({ type: "RESET" });
                }
        }

        const staySignedIn = () => {
                setShowLogoutModal(false);
                reset();
        }

        const onPrompt = () => {
                setShowLogoutModal(true);
        }

        const { getRemainingTime, reset } = useIdleTimer({
                onIdle,
                onPrompt,
                timeout: 1000 * 60 * 8,
                promptBeforeIdle: 1000 * 60 * 3,
                debounce: 500
        })
        return <>
                <UserManagementHome dealerId={dealerId} browhistory={history} />
                {showLogoutModal ?
                        <LogoutModal title="Logout Modal" isOpen={showLogoutModal} onClose={staySignedIn} />
                        :
                        <></>
                }
        </>
}
